import { Helmet } from 'react-helmet-async';
import { useNavigate } from "react-router-dom";
import '../../assets/styles/Construction.css'
import planningImg from "../../assets/images/Project Planning.png";
import estimationImg from "../../assets/images/Cost Estimator.png";
import aritechImg from "../../assets/images/AriTech Integration.png";
import siteMgmtImg from "../../assets/images/Site Management.png";
import consultancyImg from "../../assets/images/Civil Consultancy.png";

const Constructions = () => {
    const navigate = useNavigate();

    const constructionServices = [
  {
    title: "Project Planning",
    description: "Strategic planning and scheduling for construction projects using modern methodologies.",
    image: planningImg,
    path: "/services/constructions/planning"
  },
  {
    title: "Cost Estimation",
    description: "Accurate budgeting, BOQ preparation, and financial projections for construction projects.",
    image: estimationImg,
    path: "/services/constructions/estimation"
  },
  {
    title: "AriTech Integration",
    description: "Leveraging AriTech tools for automated analysis, project visualization, and decision support.",
    image: aritechImg,
    path: "/services/constructions/aritech"
  },
  {
    title: "Site Management",
    description: "On-site operations, safety protocols, material handling, and team coordination for timely delivery.",
    image: siteMgmtImg,
    path: "/services/constructions/sitemanagement"
  },
  {
    title: "Civil Consultancy",
    description: "Expert guidance and planning solutions for complex structural and infrastructure developments.",
    image: consultancyImg,
    path: "/services/constructions/consultancy"
  }
];

  return (
    <>
    <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> Construction Services – BuddyTech Solutions </title>
        <meta name="description" content="Planning, estimation, site management, consultancy and Aritech solutions for your project." />
        <meta name="keywords" content="construction planning, estimation, site management" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="Construction Services – BuddyTech Solutions" />
        <meta property="og:description" content="Planning, estimation, site management, consultancy and Aritech solutions for your project." />
        <meta property="og:keywords" content="construction planning, estimation, site management" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/constructions" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Construction Services – BuddyTech Solutions" />
        <meta name="twitter:description" content="Planning, estimation, site management, consultancy and Aritech solutions for your project." />
        <meta name="twitter:keywords" content="construction planning, estimation, site management" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
 </Helmet>
    <div className="construction-container">
      <header className="construction-hero">
        <h1>Construction Services</h1>
        <p>Providing professional construction solutions with innovation and precision planning.</p>
      </header>
      <section className="construction-services">
        {constructionServices.map((service, index) => (
          <div className="construction-card" key={index} onClick={() => navigate(service.path)}>
            <img src={service.image} alt={service.title} className="construction-card-img" />
            <div className="construction-card-body">
              <h2>{service.title}</h2>
              <p>{service.description}</p>
              <button className="construction-btn">Explore</button>
            </div>
          </div>
        ))}
      </section>
    </div>
    </>
  )
}

export default Constructions
